import { Box, Typography } from '@mui/material';
import DisabledTextField from 'components/shared/DisabledTextField';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { formatTime } from 'utils/date';

interface EventInfoProps {
  date?: string;
  activity?: string;
  start?: string;
  end?: string;
  workPlace?: string;
  qualifications?: string;
}

export default function EventInfo({
  date,
  activity,
  start,
  end,
  workPlace,
  qualifications
}: EventInfoProps) {
  const { t } = useTranslation('common');
  return (
    <Box>
      <Box paddingBottom="5px">
        <Typography variant={'h4'}>{t('appointment')}</Typography>
      </Box>
      <Box
        sx={{
          paddingTop: '10px',
          width: '768px',
          borderBottom: '1px solid grey'
        }}
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(25%,1fr))"
      >
        {date && (
          <DisabledTextField
            label={t('date')}
            value={dayjs(date).format('DD-MM-YYYY')}
            gridColumn="span 1"
          />
        )}
        {start && (
          <DisabledTextField label={t('startTime')} value={formatTime(start)} />
        )}
        {end && (
          <DisabledTextField label={t('endTime')} value={formatTime(end)} />
        )}
        <Box />
        {workPlace && (
          <DisabledTextField
            label={t('workPlace')}
            value={workPlace}
            gridColumn="span 1"
          />
        )}
        {activity && (
          <DisabledTextField label={t('activity')} value={activity} />
        )}

        {qualifications && (
          <DisabledTextField
            label={t('qualifications')}
            value={qualifications}
            fullWidth
            gridColumn="span 2"
          />
        )}
      </Box>
    </Box>
  );
}
